// extracted by mini-css-extract-plugin
export default {"HoriRule":"Report_HoriRule__2ZEaV","ReportContent":"Report_ReportContent__dmVlf"};